import useFilter from '@components/Items/utils/hooks/useFilter'
import _isArray from 'lodash/isArray'
import Pill from '@components/Items/Filters/Active/Pill'
import { QUERY_KEYS } from '@components/Items/utils/functions'

const BidftaPlus = () => {
  const { bidftaPlusQuery, updateQuery } = useFilter()
  if (!bidftaPlusQuery) return <></>

  if (_isArray(bidftaPlusQuery))
    return (
      <>
        {bidftaPlusQuery.map((bidftaPlusQueryValue) => (
          <Pill
            key={`pill-bidfta-plus-${bidftaPlusQueryValue}`}
            label={'BidFTA+ Member Only Auctions'}
            onClick={() =>
              updateQuery(QUERY_KEYS.BIDFTA_PLUS, bidftaPlusQueryValue, true)
            }
          />
        ))}
      </>
    )

  return (
    <Pill
      label={'BidFTA+ Member Only Auctions'}
      onClick={() =>
        updateQuery(QUERY_KEYS.BIDFTA_PLUS, bidftaPlusQuery, true)
      }
    />
  )
}

export default BidftaPlus
